import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaGeneralidades from "./Equipos/CreaModals/CreaGeneralidades";
import Cookies from "universal-cookie";
function Titulo1SeccionD(props) {
  const cookies = new Cookies();

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerGeneralidadesPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1]; // Encuentra la parte después del '#' que es la ruta

  return (
    <div className="test">
      <div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    1.1 Registre en la celda correspondiente el estandar
                    establecido por la institucion, segun la informacion que se
                    solicita
                  </h6>
                </div>
                <div class="card-body">
                  {cookies.get("tipo_Usuario") == 2 &&
                  nombreRuta == "ProcesoAutoevaluacion" ? (
                    <CreaGeneralidades idSolicitud={props.idSolicitud} />
                  ) : (
                    <l></l>
                  )}
                  {nombreRuta == "ProcesoAutoevaluacion" ? (
                    <a
                      href="../../../formatos/FormatoGeneralidades.csv"
                      download
                    >
                      Descargar Formato
                    </a>
                  ) : (
                    <h></h>
                  )}

                  <div class="table-responsive">
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>Perfil</th>
                          <th>Servicio </th>
                          <th>Mañana</th>
                          <th>Tarde</th>
                          <th>Noche</th>
                          <th>Fin Semana</th>
                          <th>Festivo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item) => {
                          return (
                            <tr>
                              <td>{item.id}</td>
                              <td>{item.perfil}</td>
                              <td>{item.servicio}</td>
                              <td>{item.manana}</td>
                              <td>{item.tarde}</td>
                              <td>{item.noche}</td>
                              <td>{item.fin_Semana}</td>
                              <td>{item.festivo}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo1SeccionD;
